import { useFieldInfo }            from "contexts/FieldInfoContext";
import InputMultipleEntityField from "./InputMultipleEntityField";
import InputMultipleEntityFieldLocal from "./InputMultipleEntityFieldLocal";

const InputMultipleEntitySelectField = (props: any) => {
  const { info }  = useFieldInfo()

  if (info.numOptions >= 0 && info.numOptions < 100 && !info.isDepending)
    return <InputMultipleEntityFieldLocal {...props}/>
  else
    return <InputMultipleEntityField {...props} />
}

export default InputMultipleEntitySelectField
